import moment from 'moment'
import * as TLM from '../constants/tlm'

/* A collection of Filters
 *
 */
// const ANTICIPATION_VIDEO_REGEX = ["\\b(?i)(trailer|teaser|promo|sizzle|sneak\\speak)(?<!Channel\\sTrailer)\\b"]

/** The above regex is not working in Firefox as it will not support look behind regex.
 * So using the below regex pattern which is equilant to the look behind one */

//export const ANTICIPATION_VIDEO_REGEX = ['\\b(?i)(trailer|teaser|promo|sizzle|sneak\\speak)^(?!Channel\\sTrailer).+\\b']

export const ANTICIPATION_VIDEO_REGEX = ['\\b(?i)(trailer|teaser|promo|sizzle|sneak\\speak)(?!Channel\\sTrailer)\\b']

 export class Filters {
  constructor (filters = []) {
    this._filters = Filters.sort(filters)
  }

  /* Sort an array of Filter object */
  static sort (filters) {
    return filters.sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)))
  }

  get filters () {
    return this._filters
  }

  toString () {
    return `[${this.filters.map(f => f.toString()).join(',')}]`
  }

  empty () {
    return this._filters.length === 0
  }

  contains (filter) {
    return !!this._filters.find(f => f.equals(filter))
  }

  /* More broad test of whether or not there is a filter with the topicSubType in question */
  containsTopicSubType (topicSubType) {
    return !!this._filters.find(f => f.topic_sub_type && f.topic_sub_type === topicSubType)
  }

  add (filter) {
    if (!this.contains(filter)) {
      const fNew = Filters.sort(this._filters.concat([filter]))
      return new Filters(fNew)
    } else {
      // console.debug('Skipping adding filter because it is already in there', filter)
      return this
    }
  }

  remove (filter) {
    const fNew = this._filters.filter(f => !f.equals(filter))
    Filters.sort(fNew)
    return new Filters(fNew)
  }

  /* Toggle the given filter. Add it if it's not there and remove it if it is */
  toggle (filter) {
    // Cheat and just try to remove it and if that returns the same thing, then add it.
    const without = this.remove(filter)
    if (without.filters.length === this.filters.length) {
      return this.add(filter)
    } else {
      return without
    }
  }

  equals (other) {
    // Cheat here and use JSON to compare them...sorting should be maintained, so it should work...
    return JSON.stringify(this.filters) === JSON.stringify(other.filters)
  }

  /* Reduces the list of filters to only those that are topic_sub_type filters
   *
   * We use this to undo any specilization filters we might want to like when the user selects a
   * programming filter and then selects and entity type.
   */
  consolidateToTopicSubTypes () {
    const topic_sub_types = []
    this._filters.forEach(f => {
      if (f.topic_sub_type && !topic_sub_types.includes(f.topic_sub_type)) {
        topic_sub_types.push(f.topic_sub_type)
      }
    })
    return new Filters(topic_sub_types.map(t => new Filter({
      topic_sub_type: t
    })))
  }

  /* Allow this Topic to be included? */
  allow (topic_type, topic_sub_type, labels, segments, activeDate, topic_name, rank, rankPercentage) {
    return !!this.filters.find(filter => filter.allow(topic_type, topic_sub_type, labels, segments, activeDate, topic_name, rank, rankPercentage))
  }

  /* Compute the overlapping filters shared between the filters of this object and the incoming list */
  overlapping (otherFilters = []) {
    return new Filters(this.filters.filter(f => !!otherFilters.find(o => o.equals(f))))
  }
}

/* A single filter within the list of filters
 *
 */
export class Filter {
  constructor (args = {}) {
    this.topic_type = args.topic_type
    this.topic_sub_type = args.topic_sub_type
    this.labels_or = this._wrap(args.labels_or)
    this.labels_and = this._wrap(args.labels_and)
    this.labels_not = this._wrap(args.labels_not)
    this.segments_or = this._wrap(args.segments_or)
    this.date_range = this._wrapDateRange(args.date_range)
    this.topic_name_match = args.topic_name_match
    this.threshold = args.threshold
  }

  equals (other) {
    // Cheat here and use json serialization. Sorting of arrays should
    // ensure we are comparing properly too.
    return JSON.stringify(this) === JSON.stringify(other)
    // Old implementation which was a bit too loose.
    // return this.topic_type === other.topic_type &&
    //   this.topic_sub_type === other.topic_sub_type &&
    //   this._arrayEquals(this.labels_or, other.labels_or) &&
    //   this._arrayEquals(this.labels_and, other.labels_and) &&
    //   this._arrayEquals(this.labels_not, other.labels_not)
  }

  toString () {
    const o = {
      T: this.topic_type,
      S: this.topic_sub_type,
      LO: this.labels_or,
      LA: this.labels_and,
      LN: this.labels_not,
      SO: this.segments_or,
      DR: this.date_range,
      TNM: this.topic_name_match,
      TH: this.threshold
    }
    const d = Object.keys(o).map(k => {
      if (o[k]) {
        if (Array.isArray(o[k])) {
          return `${k}:[${o[k]}]`
        }
        return `${k}:${o[k]}`
      }
      return null
    }).filter(s => !!s)
    return `{${d.join(',')}}`
  }

  /* Does this recommendation pass this filter */
  allow (topicType, topicSubType, labels, segments, activeDate, topic_name, rank, rankPercentage) {
    return (this.topic_type ? this.topic_type === topicType : true) &&
      (this.topic_sub_type ? this.topic_sub_type === topicSubType : true) &&
      this._allowLabelsOr(labels) &&
      this._allowLabelsAnd(labels) &&
      this._allowLabelsNot(labels) &&
      this._allowSegmentsOr(segments) &&
      this._allowDateRange(activeDate) &&
      this._allowNameMatch(topic_name) &&
      this._allowRankRange(rank, rankPercentage)
  }

  // Helper functions for the labels* logic

  _allowLabelsOr (labels = []) {
    if (this.labels_or) {
      return !!this.labels_or.find(l => labels.includes(l))
    }
    return true
  }

  _allowLabelsNot (labels = []) {
    if (this.labels_not) {
      return this.labels_not.map(l => labels.includes(l)).filter(l => !!l).length === 0
    }
    return true
  }

  _allowLabelsAnd (labels = []) {
    if (this.labels_and) {
      return this.labels_and.map(l => labels.includes(l)).filter(l => !!l).length === this.labels_and.length
    }
    return true
  }

  _allowSegmentsOr (segments = []) {
    if (this.segments_or) {
      return !!this.segments_or.find(s => segments.includes(s))
    }
    return true
  }

  _allowDateRange (activeDate = null) {
    if (this.date_range) {
      if (activeDate) {
        var d1 = new Date(activeDate)
        if (this.date_range.start_date && this.date_range.end_date &&
          (d1.getTime() >= new Date(this.date_range.start_date).getTime()) &&
          (d1.getTime() < new Date(this.date_range.end_date).getTime())) {
          return true
        } else if (this.date_range.start_date && !this.date_range.end_date &&
          (d1.getTime() >= new Date(this.date_range.start_date).getTime())) {
          return true
        } else if (!this.date_range.start_date && this.date_range.end_date &&
          (d1.getTime() < new Date(this.date_range.end_date).getTime())) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    return true
  }

  _allowNameMatch (name = null) {
    if (this.topic_name_match && name!==null && this.topic_sub_type===TLM.VIDEO) {
       return this.topic_name_match.map(regex => {
        let reg = null
        if (regex.indexOf('(?i)') !==-1){
          let newRegex = regex.replace('(?i)', '')
          reg=new RegExp(newRegex, 'i')
        } else {
          reg=new RegExp(regex)
      }
        return reg.test(name.toLowerCase())
       }).filter(x=>x===true).length>0?true:false
      //  flag.filter(x=>x===true).length;
      //  return totalMatches.length>0?true:false;
    }
    return true;
  }

  _allowRankRange (rank = null, rankPercentage) {
    if (this.threshold) {
      if (rank) {
        if (rank <= rankPercentage) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
    return true
  }

  // _arrayEquals(arr1, arr2) {
  //   if (arr1 === arr2) return true
  //   if (!arr1 && !arr2) return true
  //   if (!arr1 || !arr2) return false // one is null/undefined
  //   if (arr1.length !== arr2.length) return false
  //   return arr1.every((elem, pos) => elem === arr2[pos])
  // }

  _wrap (arg) {
    if (arg) {
      if (Array.isArray(arg)) {
        return arg.sort()
      } else {
        return Array.of(arg)
      }
    }
    return arg
  }

  _wrapDateRange (arg) {
    if (arg) {
      if (arg instanceof FilterDateRange) {
        return arg
      } else {
        return new FilterDateRange(arg)
      }
    }
    return arg
  }
}

export class FilterDateRange {
  constructor (args = {}) {
    this.start_date = this._wrap(args.start_date)
    this.end_date = this._wrap(args.end_date)
  }

  _wrap (arg) {
    if (arg) {
      if (typeof arg === 'string' || arg instanceof String) {
        return arg
      } else {
        return undefined
      }
    }
    return arg
  }
}

Filters.Common = {
  Empty: new Filters([]),
  Trending: new Filters([new Filter({
    topic_sub_type: TLM.VIDEO
  })]),
  Anticipation: new Filters([
    new Filter({
      topic_sub_type: 'Show',
      date_range: new FilterDateRange({
        start_date: moment(new Date()).format('YYYY-MM-DD')
      })
    }),
    new Filter({
      topic_sub_type: 'Movie',
      date_range: new FilterDateRange({
        start_date: moment(new Date()).format('YYYY-MM-DD')
      })
    }),
    new Filter({
      topic_sub_type: 'Video',
      topic_name_match: ANTICIPATION_VIDEO_REGEX
    })
  ]),
  AnticipationShowMovie: new Filters([
    new Filter({
      topic_sub_type: 'Show',
      date_range: new FilterDateRange({
        start_date: moment(new Date()).format('YYYY-MM-DD')
      })
    }),
    new Filter({
      topic_sub_type: 'Movie',
      date_range: new FilterDateRange({
        start_date: moment(new Date()).format('YYYY-MM-DD')
      })
    })
  ])
}